import { createFileRoute, redirect } from "@tanstack/react-router";
import { toast } from "react-toastify";

export const Route = createFileRoute("/app/caminhao/editar/")({
  beforeLoad: () => {
    toast.error("Caminhão não encontrado! Experimente criar um novo caminhão.");
    throw redirect({ to: "/app/caminhao/novo" });
  }
});
